import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';

import { ACCOUNTS_EDIT_INVESTMENT } from '../accountEditRoutes';
import CustomPaper from 'components/Layout/Background';

interface Props {
  riskProfile: number;
  changeLinkId?: string;
  changeTab?: () => void;
}

const Risk: React.FC<Props> = ({ riskProfile, changeLinkId, changeTab }) => {
  const { t } = useTranslation();
  const history = useHistory();
  return (
    <CustomPaper style={{ marginTop: '32px' }}>
      <Box display="flex" alignItems="center">
        <Typography variant="h3">
          {`${t('accountPlan_riskFactor')}:`}
          <Box component="strong" ml={2} mr={2}>
            {riskProfile}
          </Box>
        </Typography>
        {(changeLinkId || changeTab) && (
          <Box component="span" ml={1}>
            <Button
              variant="contained"
              onClick={
                changeTab !== undefined
                  ? changeTab
                  : () => history.push(ACCOUNTS_EDIT_INVESTMENT(changeLinkId))
              }
            >
              {t('general_change')}
            </Button>
          </Box>
        )}
      </Box>
    </CustomPaper>
  );
};

export default React.memo(Risk);
